export default function getCommaSeparated(str) {
    let values = str.trim();
    if (values !== '') {
        values = values
            .split(',')
            .reduce((result, value) => {
                const clean = value.trim();
                if (clean !== '') {
                    result.push(clean);
                }
                return result;
            }, []);
        return values;
    }
    return [];
}
